import * as React from 'react';

import './ConfigurationRename.page.scss';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { RequestApiResult } from 'loopback-react-request';
import { connect } from 'react-redux';
import { GlobalPrivateState, newConfigurationFormValues, NewConfigurationFormModel } from 'src/api';
import { ConfigurationNewForm } from 'src/app/Partials';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationRename.messages';

export interface ConfigurationRenameProps {
  dispatch: any;
  configuration: RequestApiResult<ConfigurationModel>;
}

export class ConfigurationRenamePartial extends React.Component<ConfigurationRenameProps> {
  public render() {
    return (
      <div className="page-configuration-rename d-flex justify-content-center align-items-center flex-wrap vh-100 text-center">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 offset-md-2">
              <h2 className="mb-4">
                <FormattedMessage {...MESSAGES.configurationRenameHeadline} />
              </h2>
              {this.formData && (
                <ConfigurationNewForm formFields={this.formData} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  private get formData(): NewConfigurationFormModel | undefined {
    const defaultFormData = newConfigurationFormValues();
    const name = this.configuration && this.configuration.name;

    if (!name) {
      return;  
    }
    defaultFormData.name.value = name;
    return defaultFormData;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }
}

export const ConfigurationRename = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(ConfigurationRenamePartial);

export default ConfigurationRename;
